import { Platform } from './enums';

// 项目内业务相关的配置
localStorage.setItem('PLATFORM', Platform.HXORGANIZATION.toString());

import('./bootstrap');

export {};
